import React from 'react';

import { currencyCell, leadAttorneyTemplate, nameTemplate } from 'modules/reports/components/TableCell/TableCell';
import ResizableDataTable from 'components/ResizableDataTable/ResizableDataTable';

export default function Table({ list, paginatorTemplate, pageLimit, due_amount, running_trust_balance }) {
  return (
    <ResizableDataTable
      value={list}
      responsiveLayout="scroll"
      className="p-datatable-responsive"
      emptyMessage="No Data Found."
      paginatorTemplate={paginatorTemplate}
      rows={pageLimit}
      sortField=""
      stripedRows
      paginator
      columns={[
        {
          field: 'case_description.case_name',
          header: 'Cases with Trust Balance',
          body: nameTemplate,
          sortable: true,
          bodyClassName: 'ellipsis-text',
        },
        { field: 'running_trust_balance', header: 'Balance', body: currencyCell, sortable: true, bodyClassName: 'ellipsis-text' },
        { field: 'due_amount', header: 'Past Due to Trust', body: currencyCell, sortable: true, bodyClassName: 'ellipsis-text' },
        {
          field: 'leadAttorney.attorney_name',
          header: 'Lead Attorney',
          body: leadAttorneyTemplate,
          sortable: true,
          bodyClassName: 'ellipsis-text',
        },
      ]}
      storageKey="trust_account_txn_report_column_widths"
    />
  );
}
